<span class="header-menu-div">
  <button *ngIf="systemMessagePopupEnabled()" mat-raised-button matTooltip="System Notifications" (click)="openSystemMessagePopup()">
    <mat-icon class="material-symbols-outlined notifications-icon-green">
    add_comment
    </mat-icon>
  </button>
  <app-user-notifications *ngIf="user != null && !user.anonymous"></app-user-notifications>
  <app-current-user></app-current-user>
</span>
